module.exports = __webpack_public_path__ + "static/avatar_2-5f6ef0ad9625dba7bae8fe7ce8992561.png";